<template>
  <div class="r2r-chat">
    <div class="wrapper">
      <div class="title">
        Robot is chatting
      </div>
      <div class="dots">
        <div class="dot" />
        <div class="dot" />
        <div class="dot" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'R2RChatComponent',
};
</script>

<style lang="scss" scoped>
  .r2r-chat {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 360px;
    max-height: 80%;

    @media screen and (min-width: $desktop_m_breakpoint) {
      height: auto;
      max-height: none;
    }

    @media screen and (orientation: portrait) {
      height: 35%;
    }

    @media screen and (min-height: $big_vertical_screen_breakpoint) {
      height: 1410px !important;
    }

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 100%;
      height: 100%;
      background-color: #fff;
      border-radius: 16px;
      box-shadow: 0 2px 16px rgba(141, 151, 159, 0.1);
      z-index: 1;

      @media screen and (min-width: $desktop_m_breakpoint) {
        height: 50vh;
        width: 50vw;
      }

      @media screen and (orientation: portrait) {
        height: 100%;
        width: 100%;
      }

      @media screen and (min-height: $big_vertical_screen_breakpoint) {
        height: 100%;
        width: 100%;
      }
    }
  }

  .wrapper {
    position: relative;
    z-index: 2;
  }

  .title {
    font-weight: 500;
    font-size: 28px;
    line-height: 32px;
    letter-spacing: 0.25px;
    margin-bottom: 32px;

    @media screen and (min-width: $desktop_m_breakpoint) {
      font-size: 32px;
      line-height: 42px;
      margin-bottom: 65px;
    }

    @media screen and (min-width: $desktop_l_breakpoint) {
      font-size: 70px;
      line-height: 120%;
      margin-bottom: 75px;
    }

    @media screen and (min-height: $big_vertical_screen_breakpoint) {
      font-size: 168px;
      line-height: 120%;
      margin-bottom: 200px;
    }
  }

  .dots {
    height: 17px;
    display: flex;
    justify-content: center;

    .dot {
      border-radius: 100%;
      width: 17px;
      height: 17px;
      margin: 0 2px;
      background-color: #007CBA;

      transform: scale(0);

      animation-duration: 0.75s;
      animation-name: scalein;
      animation-iteration-count: infinite;
      animation-direction: alternate;

      &:nth-child(2) {
        animation-delay: 0.25s;
      }
      &:nth-child(3) {
        animation-delay: 0.5s;
      }
    }

    @media screen and (min-width: $desktop_l_breakpoint) {
      height: 30px;

      .dot {
        width: 30px;
        height: 30px;
        margin: 0 4px;
      }
    }

    @media screen and (min-height: $big_vertical_screen_breakpoint) {
      height: 70px;

      .dot {
        width: 70px;
        height: 70px;
        margin: 0 8px;
      }
    }
  }

  @keyframes scalein {
    from {
      transform: scale(0);
    }

    to {
      transform: scale(1);
    }
  }
</style>
